/*!

=========================================================
* exceed - v1.0.0
=========================================================
* Coded by Ecrubit
*/
import React from "react";
import { Link } from "react-router-dom";
import { AnchorScroll } from "helper";
// reactstrap components
import {

  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Row,
  Col
} from "reactstrap";
import { FaTimes } from "react-icons/fa";
import { FiMenu } from 'react-icons/fi';


export default function IndexNavbar() {
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [collapseOut, setCollapseOut] = React.useState("");

  const toggleCollapse = () => {
    document.documentElement.classList.toggle("nav-open");
    setCollapseOpen(!collapseOpen);
  };
  const onCollapseExiting = () => {
    setCollapseOut("collapsing-out");
  };
  const onCollapseExited = () => {
    setCollapseOut("");
  };

  return (
    <Navbar expand="lg" className="bg-nav px-0">
      <div className="w-100 nav-border">
        <Row className="d-flex align-items-center justify-content-center">
          <Col lg="2">
            <div className="d-flex align-items-center justify-content-between py-1">
              <NavbarBrand className="py-2" to="/" tag={Link} id="navbar-brand" onClick={() => AnchorScroll()}>
                <img src={require('../../assets/img/logo.png').default} alt='logo' className='img-fluid pl-2 pl-lg-4' />
              </NavbarBrand>
              <button
                aria-expanded={collapseOpen}
                className="navbar-toggler navbar-toggler mt-0"
                onClick={toggleCollapse}
              >
                <FiMenu className="text-dark" size="24" />
              </button>
            </div>
          </Col>
          <Col lg="9" className="text-lg-center px-lg-0">
            <Collapse
              className={"justify-content-end " + collapseOut}
              navbar
              isOpen={collapseOpen}
              onExiting={onCollapseExiting}
              onExited={onCollapseExited}
            >
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-column flex-lg-row justify-content-between">
                  <Nav className="nav-link-space d-flex flex-column flex-lg-row">
                    <NavItem>
                      <a href="/#" className="ff-regular px-lg-4">Home</a>
                    </NavItem>
                    <NavItem>
                      <a href="/#about" className="ff-regular px-lg-4">About Us</a>
                    </NavItem>
                    <NavItem>
                      <a href="/#nfts" className="ff-regular px-lg-4">NFTs</a>
                    </NavItem>
                    <NavItem>
                      <a href="/#benefits" className="ff-regular px-lg-4">Benefits</a>
                    </NavItem>
                    {/* <NavItem>
                      <a href="/#roadmap" className="ff-regular px-lg-3">Roadmap</a>
                    </NavItem> */}
                    <NavItem>
                      <a href="/#faqs" className="ff-regular px-lg-4">FAQs</a>
                    </NavItem>
                  </Nav>
                </div>
                <div className="navbar-collapse-header">
                  <Row>
                    <Col className="collapse-close" xs="6">
                      <button
                        aria-expanded={collapseOpen}
                        onClick={toggleCollapse}
                      >
                        <FaTimes className="pf-text-secondary" size="24" />
                      </button>
                    </Col>
                  </Row>
                </div>
              </div>
              <a href="#" className="text-white"><button className="btn-pzza d-block d-lg-none py-2 px-4 mt-4 mt-lg-0 ff-bold">CONNECT WALLET</button></a>
            </Collapse>
          </Col>
          {/* <Col lg="3" className="text-right d-none d-lg-flex justify-content-end">
            <a href="#" className="text-white"><button className="btn-pzza py-3 px-3 px-xl-5 mt-4 mt-lg-0 ff-bold">CONNECT WALLET</button></a>
          </Col> */}
        </Row>
      </div>
    </Navbar>
  );
}
